
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ru/gallery",
      function () {
        return require("private-next-pages/ru/gallery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ru/gallery"])
      });
    }
  